<div class="btn-content" matRipple matRippleColor="rgba(255, 255, 255, 0.2)" [matRippleDisabled]="load">
  <span [style.opacity]="load ? 0 : 1">
    <ng-content></ng-content>
  </span>
  @if (load) {
    <mat-spinner class="spinner" ctrSpinnerHotel [useContrastColor]="true" diameter="30"></mat-spinner>
  }
</div>
